import { useCallback } from 'react';
import { UserFields } from 'src/model/enum/dataEnums';
import useProgress from '../data/useProgress';

export const useTimeZone = () => {
    const { saveProgress } = useProgress()



    const checkTimezone = useCallback(async () => {
        saveProgress({ Action: 'user-data', Value: `${UserFields.UtcOffset}=${3.5}` });
    }, [saveProgress]);

    return {
        checkTimezone
    };
};
